// extracted by mini-css-extract-plugin
export default {"wrapper":"rY3A1 ZdH1P","mainGallery":"ZhozE","topArticles":"ht8v_","popularTags":"x9UJn","additionalOffers":"krKMa","dynamicCatalog":"htTE4"};